module.exports = __webpack_public_path__ + "static/media/fb.3563f52e.svg";